/* src/app/users/edit-user/edit-user.component.css */
.user-form-section {
  border-top: 1px solid rgba(148, 163, 184, 0.28);
  padding-top: 1rem;
}
.user-form-section-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}
.user-form-section-badge {
  display: inline-flex;
  align-items: center;
  border: 1px solid rgba(148, 163, 184, 0.4);
  background: #fff;
  border-radius: 999px;
  padding: 0.35rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #334155;
}
.user-form-section-note {
  font-size: 0.95rem;
  color: #64748b;
}
.user-role-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.75rem;
}
.user-role-option {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.85rem 0.95rem;
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 0.9rem;
  background: rgba(255, 255, 255, 0.82);
}
.user-role-label {
  cursor: pointer;
  line-height: 1.3;
}
.user-role-name {
  display: block;
  font-weight: 600;
  color: #0f172a;
}
.user-selection-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
.user-multiselect-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.25rem 0 0.75rem;
}
.user-multiselect-title {
  font-size: 0.875rem;
  font-weight: 700;
  color: #0f172a;
}
.user-multiselect-subtitle {
  margin-top: 0.15rem;
  font-size: 0.8rem;
  color: #64748b;
}
:host ::ng-deep .p-fieldset {
  border-color: rgba(148, 163, 184, 0.25);
  background: rgba(255, 255, 255, 0.58);
  margin-bottom: 1.25rem;
}
:host ::ng-deep .p-fieldset .p-fieldset-legend {
  border: 1px solid rgba(148, 163, 184, 0.32);
  background: #fff;
  font-weight: 700;
  color: #334155;
}
:host ::ng-deep .p-autocomplete {
  width: 100%;
}
:host ::ng-deep .p-autocomplete .p-autocomplete-input,
:host ::ng-deep .p-autocomplete-multiple-container {
  width: 100%;
}
:host ::ng-deep .p-autocomplete .p-autocomplete-multiple-container {
  min-height: 3rem;
  align-items: center;
}
:host ::ng-deep .p-autocomplete .p-autocomplete-token {
  margin: 0.2rem 0.25rem 0.2rem 0;
}
/*# sourceMappingURL=edit-user.component-QC3QLPSW.css.map */
